import React from 'react';
// import { useHistory } from 'react-router-dom';
import Table from '../components/Table/Table';
import usePpsis from '../features/PpsiContainer/hooks/usePpsis';
// import { ppsiPublishedRoute } from '../routes';
import { EnrichmentData, States } from '../features/PpsiContainer/constants';
import useViewVisited from '../features/app/hooks/useViewVisted';
import ppsiColumns from '../features/PpsiContainer/ui/columns';
import { toJS } from '../utils/immutableUtils';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';

const Columns = ppsiColumns(EnrichmentData.PUBLISHED);

const PpsiPublishedListView = () => {
  // const history = useHistory();
  const [isFetching, ppsisRaw] = usePpsis({ status: States.PUBLISHED });
  const { isViewVisited } = useViewVisited(
    View.PpsiListPublished.name,
    isFetching
  );
  const isFetched = isViewVisited ? true : !isFetching;
  const ppsis = toJS(ppsisRaw, []);

  // const viewPublishedPpsi = ppsi => {
  //   history.push(ppsiPublishedRoute(ppsi.id));
  // };

  View.PpsiListPublished.visit();

  return (
    <PaperContainer showProgress={!isFetched}>
      <Table
        title="ppsi.publishedListTableTitle"
        data={ppsis}
        columns={[
          Columns.IfoodID,
          Columns.PresentationName,
          Columns.PiaNumber,
          Columns.LifeCycleStatusForPublished,
          // Columns.RangeCategory,
          Columns.Version,
          Columns.ActualPublishDate,
          // Columns.PublishedBy,
          Columns.Updates
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        // onRowClick={viewPublishedPpsi}
      />
    </PaperContainer>
  );
};

export default PpsiPublishedListView;
